<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }" v-if="ShowButton">
       <!-- <v-btn color="primary" class="white--text" v-bind="attrs" v-on="on" >Thêm mới <v-icon right>mdi mdi-car-off</v-icon> </v-btn> -->
        <v-btn color="primary" class="white--text" v-bind="attrs" v-on="on" >Thêm xe <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn> 
      </template>
      <v-card>
        <v-form ref="form" lazy-validation>
        <v-card-title>
          <span class="text-h5" v-if="!addData.TrackId">Thêm xe vượt trạm</span>
          <span class="text-h5" v-else>Cập nhật xe vượt trạm</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="8"
              >
                <v-text-field
                  v-model="addData.LicensePlates"
                  label="Biển số xe:"
                  :rules="Rules.LicensePlates"
                  counter="9"
                  required
                  @change="CheckValid"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                  <v-btn color="#008a43" class="white--text" @click=TimKiem360>Tìm 360 <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="addData.NameCustomer"
                  label="Tên khách hàng:"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="addData.Lane"
                  :items="ListLane"
                  label="Làn:"
                  item-value="LaneID"
                  item-text="LaneName"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <DateTimePicker lang="en" :date-time.sync="TrackTime" label="Thời gian:" placeholder="Thời gian"/>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-select
                  v-model="addData.TrackFee"
                  :items="ListFee"
                  label="Mệnh giá:"
                  item-value="IdFee"
                  item-text="FeeNumbers"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="addData.Notes"
                  label="Ghi chú:"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Đóng
          </v-btn>
          <v-btn
            color="green"
            :disabled="disabled"
            :loading="loading"            
            @click="TaoMoi"
            class="white--text"
            v-if="!addData.TrackId"
          >
            Tạo
          </v-btn>
          <v-btn
            color="green"
            :loading="loading"            
            @click="CapNhat"
            class="white--text"
            v-else
          >
            Cập nhật
          </v-btn>
        </v-card-actions>
      </v-form>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    data: (vm) => ({
      editItem: {},
      TrackTime: undefined,
      addData: {},
      dialog: false,
      loading:false,
      disabled: true,
      Swal: vm.$swal,
      moment: vm.moment
    }),
    props: {
      ListFee: Array,
      ListLane: Array,
      Rules: Object,
      isUpdated: Boolean,
      ShowButton: {
        type: Boolean,
        defaut: true,
        required: false,
      },
    },
    methods: {
      EditItem(item){
        delete item.CreateByUser;
        delete item.Image;
        delete item.Status;
        delete item.createdAt;
        delete item.updatedAt;
        delete item.fee;
        delete item.lane;
        delete item.user;
        this.addData = item;
        this.TrackTime = item.TrackTime;
        this.dialog = true;
      },
      TimKiem360(){
        const biensoxe = this.addData.LicensePlates;
        this.$Request.get(`/360search/${biensoxe}`).then(response => {
            if(response.data.success === true)
            {
              const json = response.data.data;
              if(json.OWNER) this.addData.NameCustomer = json.OWNER;
              if(json.ETAG) this.addData.Notes += `\nETAG: ${json.ETAG}`;
              if(json.TrackFee) this.addData.TrackFee = json.TrackFee;
            }else{
              const msg = response.data.error || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      CapNhat(){
        this.loading = true;
        this.$Request.post('/track/update',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.addData = this.dataDefault;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã cập nhật thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.msg || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      TaoMoi(){
        this.loading = true;
        this.$Request.post('/track/create',this.addData).then(response => {
            if(response.data.success === true)
            {
              this.dialog = false;
              this.addData = this.dataDefault;
              this.$emit("update:isUpdated", true);
              const msg = response.data.msg || "Đã thêm thành công !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }else{
              const msg = response.data.msg || "Có lỗi xảy ra !";
              this.Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: msg,
                  showConfirmButton: false,
                  timer: 1500
              });
            }
        }).finally(()=>{
          this.loading = false;
        });
      },
      CheckValid(){
        if(this.$refs.form === undefined){
          this.disabled = true;
        }else{
          this.disabled = (this.addData.TrackTime === undefined) ? true:!this.$refs.form.validate();
        }
      }
    },
    watch: {
      TrackTime:function(newVal){
        this.addData.TrackTime = this.moment(newVal).tz("Asia/Bangkok").format("YYYY-MM-DD HH:MM");
        this.CheckValid();
      }
    },
    computed: {
      dataDefault(){
        return {
          'LicensePlates':"",
          'NameCustomers':"",
          'Lane':1,
          'TrackTime':undefined,
          'TrackFee':0,
          'Notes': ""
        };
      },
      isValid(){
        if(typeof(this.$refs.form) === "undefined") return false;
        return this.$refs.form.validate();
      }
    },
    mounted(){
      this.addData = this.dataDefault;
    }
}
</script>